/**
 * Created by DELL on 2016/12/16.
 */
import {
  SHOW_TAB,
  CLOSE_TAB,
  SWITCH_TAB,
  SELECT_WORKSTOP,
  SET_TAB_SHOW,
  SET_TAB_CLOSE,
  SET_TAB_SELECT,
  RESET_TAB_SELECT,
  CLEAR_TABS,
  SWITCH_LIST,
  LIST_SET,
  SHOW_SHORTCUT,
  CLOSE_SHORTCUT,
  SET_SHORTCUT_SHOW,
  SET_SHORTCUT_CLOSE,
  GET_SHORTCUT,
  JUMP_ROUTE
  /* HOME_NEWS_DETAIL,
  HOME_NEWS_DETAIL_SHOW,
  SHOW_TOAST,
  SET_LOADING,
  LOAD_PANELTOP,
  LOAD_PANELTOP_REFRESH,
  LOAD_PANELBOTTOM,
  LOAD_PANELBOTTOM_REFRESH,
  SET_REFRESH */
} from '../types'
import tabArr from '../../utils/tabArr'
import navlist from '../../data/navlist'
// import {homePageNewsDetail, homePageNavList, homePagePanelTop, homePagePanelTopRefresh, homePagePanelBottom, homePagePanelBottomRefresh} from '../../api'

/* homePageNavList().then((response) => {
  homeModule.state.navList = response.body
  for (let i = 0; i < response.body.length; i++) {
    homeModule.state.navList[i].src = require('../../assets/image/home_navitems/' + response.body[i].src)
  }
}, (response) => {
  console.log(response)
})
homePagePanelTop().then((response) => {
  homeModule.state.panelTop = response.body
}, (response) => {
  console.log(response)
})
homePagePanelBottom().then((response) => {
  homeModule.state.panelBottom = response.body
}, (response) => {
  console.log(response)
}) */

const homeModule = {
  state: {
    navList: navlist,
    shortcutId: window.localStorage.getItem('shortcutId') ? window.localStorage.getItem('shortcutId') : '',
    /* panelTop: [],
    panelBottom: [], */
   /* rotateTop: false,
    rotateBottom: false, */
    selection: window.sessionStorage.getItem('selection') ? window.sessionStorage.getItem('selection') : 'workstop', // 被选中的tab
    tabs: window.sessionStorage.getItem('tabs') ? window.sessionStorage.getItem('tabs').split(',') : [], // 打开的tabs
    shortcuts: [], // 添加的快捷链接
    newsDetail: '<img src="http://cdn.uehtml.com/201402/1392662591224_1140x0.gif" width="400" height="300">' //
  },
  mutations: {
    [JUMP_ROUTE] (state, item) {
      let go = '/home/' + item.go
      window.router.push({path: go, query: { refresh: item.refresh }})
    },
    [SET_TAB_SHOW] (state, item) {
      item.show = true
      tabArr.addTab(state.tabs, item.id) // tabs数组增加tab
      window.sessionStorage.setItem('tabs', state.tabs.join(',')) // 更新localStorage
    },
    [SET_TAB_CLOSE] (state, item) {
      item.show = false
      tabArr.removeTab(state.tabs, item.id)// tabs数组删除tab
      window.sessionStorage.setItem('tabs', state.tabs.join(','))// 更新localStorage
    },
    [SET_TAB_SELECT] (state, item) {
      state.selection = item.id
      window.sessionStorage.setItem('selection', item.id)
      // window.router.push(go)
    },
    [RESET_TAB_SELECT] (state) {
      state.selection = 'workstop'
      window.sessionStorage.setItem('selection', 'workstop')
      window.router.push('/home')
    },
    [CLEAR_TABS] (state) {
      state.tabs = []
      state.shortcuts = []
    },
    [LIST_SET] (state, item) {
      state.list = item.link
      state.navTitle = item.title
    },
    [SET_SHORTCUT_SHOW] (state, item) {
      item.shortcut = true
      tabArr.addTab(state.shortcuts, item.id) // shortcuts数组增加快捷链接
      if (state.shortcutId) window.localStorage.setItem(state.shortcutId, state.shortcuts.join(',')) // 更新localStorage
    },
    [SET_SHORTCUT_CLOSE] (state, item) {
      item.shortcut = false
      tabArr.removeTab(state.shortcuts, item.id) // shortcuts数组删除快捷链接
      if (state.shortcutId) window.localStorage.setItem(state.shortcutId, state.shortcuts.join(',')) // 更新localStorage
    },
    [GET_SHORTCUT] (state, userInfo) {
      // state.shortcuts = window.localStorage.getItem(state.userId) ? window.localStorage.getItem(state.userId).split(',') : []
      let shortcutId = userInfo ? (userInfo.userId + 'shortcut') : state.shortcutId
      if (shortcutId) {
        state.shortcutId = shortcutId
        state.shortcuts = window.localStorage.getItem(shortcutId) ? window.localStorage.getItem(shortcutId).split(',') : []
      } else {
        state.shortcutId = ''
        state.shortcuts = []
      }
    }
    /* [HOME_NEWS_DETAIL_SHOW] (state, content) {
      state.newsDetail = content
    },
    [LOAD_PANELTOP_REFRESH] (state, content) {
      // state.panelTop = content
      for (let i = 0; i < content.length; i++) {
        state.panelTop[i].num = content[i].num
      }
    },
    [LOAD_PANELBOTTOM_REFRESH] (state, content) {
      state.panelBottom = content
    },
    [SET_REFRESH] (state, detail) {
      if (detail.type === 'top') {
        state.rotateTop = true
        setTimeout(function () {
          state.rotateTop = false
        }, detail.time)
      } else if (detail.type === 'bottom') {
        state.rotateBottom = true
        setTimeout(function () {
          state.rotateBottom = false
        }, detail.time)
      }
    } */
  },
  actions: {
    [SHOW_TAB] ({commit}, item) {
      /* 如果所打开的tab没有关闭 则直接从内存加载 */
      commit(SET_TAB_SHOW, item)
      commit(SET_TAB_SELECT, item)
      // if (state.tabs.indexOf(item.id) > -1) {
      //   commit(JUMP_ROUTE, {...item, refresh: false})
      // } else {
      //   commit(JUMP_ROUTE, {...item, refresh: true})
      // }
      if (!item.notRouteUpdate) {
        commit(JUMP_ROUTE, {...item, refresh: true})
      }
    },
    [CLOSE_TAB] ({commit, state}, item) {
      commit(SET_TAB_CLOSE, item)
      if (state.selection === item.id) {
        commit(RESET_TAB_SELECT)
      }
    },
    [SWITCH_TAB] ({commit}, item) {
      commit(SET_TAB_SELECT, item)
      commit(JUMP_ROUTE, {...item, refresh: false})
    },
    [SELECT_WORKSTOP] ({commit}) {
      commit(RESET_TAB_SELECT)
    },
    [SWITCH_LIST] ({commit}, item) {
      commit(LIST_SET, item)
    },
    [SHOW_SHORTCUT] ({commit}, item) {
      commit(SET_SHORTCUT_SHOW, item)
    },
    [CLOSE_SHORTCUT] ({commit}, item) {
      commit(SET_SHORTCUT_CLOSE, item)
    }
    /* [HOME_NEWS_DETAIL] ({commit, dispatch}, id) {
      commit(SET_LOADING, 50)
      homePageNewsDetail(id).then((res) => {
        commit(SET_LOADING, 80)
        if (res.data.code === '0') {
          commit(SET_LOADING, 100)
          commit(HOME_NEWS_DETAIL_SHOW, res.data.data.pictorial.pictorialContent)
        } else {
          commit(SET_LOADING, 100)
          dispatch(SHOW_TOAST, '获取失败')
        }
      }, (res) => {
        commit(SET_LOADING, 100)
        dispatch(SHOW_TOAST, '获取失败')
      })
    },
    [LOAD_PANELTOP] ({commit, state, dispatch}) {
      homePagePanelTopRefresh().then((res) => {
        commit(SET_REFRESH, {time: 500, type: 'top'})
        if (res.data) {
          commit(SET_REFRESH, {time: 300, type: 'top'})
          commit(LOAD_PANELTOP_REFRESH, res.data)
        }
      }, (res) => {
        commit(SET_REFRESH, {time: 500, type: 'top'})
        dispatch(SHOW_TOAST, '获取失败')
      })
    },
    [LOAD_PANELBOTTOM] ({commit, state, dispatch}) {
      homePagePanelBottomRefresh().then((res) => {
        commit(SET_REFRESH, {time: 500, type: 'bottom'})
        if (res.data) {
          commit(LOAD_PANELBOTTOM_REFRESH, res.data)
          commit(SET_REFRESH, {time: 300, type: 'bottom'})
        }
      }, (res) => {
        commit(SET_REFRESH, {time: 500, type: 'bottom'})
        dispatch(SHOW_TOAST, '获取失败')
      })
    } */
  },
  getters: {
  }
}
export default homeModule



// WEBPACK FOOTER //
// ./src/store/modules/home.js